module.exports = __webpack_public_path__ + "img/s3-modal.917dcd6e.jpg";